import bus from "@/bus";
const pixelDb = require(`./${_BBVA_MOTOR}/pixelDb.js`).default;
import pxRunner from "./runner";
import { ON_ROUTE } from "../config/constants/mutation-types";

const pixels = {
  initProvider(key, provider, Vue) {
    pxRunner.enableProvider(provider, () => {
      Vue.$log.info(
        `se habilitó el provider: ${key}. Ejecutando la cola de pxs probablemente llamados`
      );

      if (provider.queue && provider.queue.length > 0) {
        for (let q = 0; q < provider.queue.length; q++) {
          Vue.$log.info(`Procesando cola de provider: ${key}`);
          provider.queue[q]();
        }
      }
    });
  },
  install(Vue) {
    for (let key in pixelDb.providers) {
      pixels.initProvider(key, pixelDb.providers[key], Vue);
    }

    bus.$on("mutation", mutationObj => {
      let mutation = mutationObj.mutation;
      // Hay un trigger para este tipo de mutation ?
      let trigger = pixelDb.triggers[mutation.type];
      if (trigger) {
        // El trigger 'ON_ROUTE' lleva el nombre del route, dentro del payload
        let phases = null;
        if (mutation.type === ON_ROUTE) {
          phases = trigger[mutation.payload.name];
        } else {
          phases = trigger;
        }
        // Si tiene phases avanzo
        if (phases) {
          for (let i = 0; i < phases.length; i++) {
            pxRunner.run(phases[i], mutationObj);
          }
        }
      }
    });
  }
};

export default pixels;
